import { ReactNode } from 'react';
import { InterviewTypes } from '@/utils/interviews';
import * as Styles from './WelcomingInterviewContainer.styles';

export type WelcomingInterviewContainerProps = {
  firstName: string;
  interviewType: InterviewTypes;
  children: ReactNode;
  onClickNextStep: () => void;
};

const interviewInfo = {
  [InterviewTypes.PRE_SCREENING]: {
    title: 'Pre-Screening Interview',
    buttonLabel: 'Start Answering',
  },
  [InterviewTypes.TECHNICAL_CHALLENGE]: {
    title: 'Technical Challenge',
    buttonLabel: 'Submit your project',
  },
};

export default function WelcomingInterviewContainer({
  firstName,
  interviewType,
  children,
  onClickNextStep,
}: WelcomingInterviewContainerProps): JSX.Element {
  return (
    <>
      <Styles.Hero>
        <Styles.HeroContainer isSmaller>
          <Styles.CandidateGreetings>Hi, {firstName}!</Styles.CandidateGreetings>
        </Styles.HeroContainer>
      </Styles.Hero>

      {children}

      <div className="flex justify-center">
        <Styles.CustomButton onClick={onClickNextStep} size="medium" variantColor="yellow">
          {interviewInfo[interviewType].buttonLabel}
        </Styles.CustomButton>
      </div>
    </>
  );
}
